export const HOME = 'HOME';
export const ERROR = 'ERROR';
export const ERROR_FATAL_CODE = 'ERROR_FATAL_CODE';
export const ERROR_RETRY_CODE = 'ERROR_RETRY_CODE';
export const ERROR_MEDIUM_CODE = 'ERROR_MEDIUM_CODE';
export const ERROR_PARTNER_ADAPTER = 'ERROR_PARTNER_ADAPTER';

export const PRODUCT_CATALOGUE = 'PRODUCT_CATALOGUE';
export const PRODUCT_DETAILS = 'PRODUCT_DETAILS';
export const PRODUCT_ORDER_SELECTION = 'PRODUCT_ORDER_SELECTION';
export const PRODUCT_ORDER_FINALIZE = 'PRODUCT_ORDER_FINALIZE';
export const PRODUCT_ORDER_ACCOUNT_FINALIZE = 'PRODUCT_ORDER_ACCOUNT_FINALIZE';
export const PRODUCT_ORDER_RESERVATION_CONFIRMATION = 'PRODUCT_ORDER_RESERVATION_CONFIRMATION';
export const PRODUCT_ORDER_SUMMARY = 'PRODUCT_ORDER_SUMMARY';
export const PRODUCT_ORDER_SUMMARY_RETURN = 'PRODUCT_ORDER_SUMMARY_RETURN';
export const PRODUCT_ORDER_SUMMARY_OPENID_RETURN = 'PRODUCT_ORDER_SUMMARY_OPENID_RETURN';
export const PRODUCT_ORDER_SUMMARY_FINALIZE = 'PRODUCT_ORDER_SUMMARY_FINALIZE';
export const PRODUCT_ORDER_SUMMARY_OPTIN = 'PRODUCT_ORDER_SUMMARY_OPTIN';
export const PRODUCT_ORDER_CONFIRMATION = 'PRODUCT_ORDER_CONFIRMATION';
export const PRODUCT_ORDER_CONFIRMATION_OPTIN = 'PRODUCT_ORDER_CONFIRMATION_OPTIN';
export const PRODUCT_ORDER_CONFIRMATION_FINALIZE = 'PRODUCT_ORDER_CONFIRMATION_FINALIZE';
export const PRODUCT_ADMINISTRATION_SELECTION = 'PRODUCT_ADMINISTRATION_SELECTION';
export const PRODUCT_ADMINISTRATION_SUMMARY = 'PRODUCT_ADMINISTRATION_SUMMARY';
export const PRODUCT_ADMINISTRATION_CONFIRMATION = 'PRODUCT_ADMINISTRATION_CONFIRMATION';
export const PRODUCT_ADMINISTRATION_CONFIRMATION_IN_PROGRESS = 'PRODUCT_ADMINISTRATION_CONFIRMATION_IN_PROGRESS';

export const STOCK = 'STOCK';
export const STOCK_PRODUCT_CHANGE_SELECTION = 'STOCK_PRODUCT_CHANGE_SELECTION';
export const STOCK_PRODUCT_CHANGE_SUMMARY = 'STOCK_PRODUCT_CHANGE_SUMMARY';
export const STOCK_PRODUCT_CHANGE_CONFIRMATION = 'STOCK_PRODUCT_CHANGE_CONFIRMATION';

export const PAYMENT_GENERATION = 'PAYMENT_GENERATION';
export const PAYMENT_GENERATION_DATA = 'PAYMENT_GENERATION_DATA';
export const PAYMENT_GENERATION_SUMMARY = 'PAYMENT_GENERATION_SUMMARY';
export const PAYMENT_GENERATION_CONFIRMATION = 'PAYMENT_GENERATION_CONFIRMATION';

export const AUTO_TOPUP_REGISTRATIONS = 'AUTO_TOPUP_REGISTRATIONS';
export const AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS = 'AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS';

export const PAYMENT_TRANSACTIONS = 'PAYMENT_TRANSACTIONS';
export const PAYMENT_TRANSACTIONS_OVERVIEW = 'PAYMENT_TRANSACTIONS_OVERVIEW';
export const PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS = 'PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS';
export const RECHARGE_TRANSACTIONS = 'RECHARGE_TRANSACTIONS';
export const RECHARGE_TRANSACTIONS_OVERVIEW = 'RECHARGE_TRANSACTIONS_OVERVIEW';
export const RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS = 'RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS';
export const CONTENT_BUNDLES = 'CONTENT_BUNDLES';
export const CONTENT_BUNDLES_OVERVIEW = 'CONTENT_BUNDLES_OVERVIEW';
export const CONTENT_BUNDLES_OVERVIEW_DETAILS = 'CONTENT_BUNDLES_OVERVIEW_DETAILS';

export const PERSISTENT_CONFIRMATIONS = 'PERSISTENT_CONFIRMATIONS';
export const PERSISTENT_CONFIRMATIONS_DETAILS = 'PERSISTENT_CONFIRMATIONS_DETAILS';

export const CUSTOMER_SEARCH = 'CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_REDIRECT = 'CUSTOMER_SEARCH_REDIRECT';
export const CONTRACT_SEARCH = 'CONTRACT_SEARCH';
export const CONTRACT_SEARCH_REDIRECT = 'CONTRACT_SEARCH_REDIRECT';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const PROFILE = 'PROFILE';
export const PASSWORD = 'PASSWORD';

export const BARRING_FACTORING_STATUS = 'BARRING_FACTORING_STATUS';
export const BARRING_FACTORING_EDIT = 'BARRING_FACTORING_EDIT';
export const BARRING_FACTORING_EDIT_EXCEPTIONS = 'BARRING_FACTORING_EDIT_EXCEPTIONS';
export const BARRING_FACTORING_HISTORY = 'BARRING_FACTORING_HISTORY';
export const BARRING_FACTORING_HISTORY_STATUS = 'BARRING_FACTORING_HISTORY_STATUS';
export const BARRING_FACTORING_HISTORY_SHOW = 'BARRING_FACTORING_HISTORY_SHOW';
export const BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS = 'BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS';
export const BARRING_RESELLING_STATUS = 'BARRING_RESELLING_STATUS';
export const BARRING_RESELLING_EDIT = 'BARRING_RESELLING_EDIT';
export const BARRING_RESELLING_HISTORY = 'BARRING_RESELLING_HISTORY';
export const BARRING_RESELLING_HISTORY_STATUS = 'BARRING_RESELLING_HISTORY_STATUS';
export const BARRING_PIN_PROTECTION = 'BARRING_PIN_PROTECTION';

export const TEST = 'TEST';
export const TEST_GENERAL = 'TEST_GENERAL';
export const TEST_SUBSTORE = 'TEST_SUBSTORE';
export const TEST_BARRING = 'TEST_BARRING';
export const TEST_ANONYMOUS = 'TEST_ANONYMOUS';
export const TEST_PRICE = 'TEST_PRICE';
export const TEST_PRICEDETAILS = 'TEST_PRICEDETAILS';
export const TEST_PRODUCT = 'TEST_PRODUCT';
export const TEST_STOCKPRODUCT = 'TEST_STOCKPRODUCT';
export const TEST_SUBSCRIPTION = 'TEST_SUBSCRIPTION';
export const TEST_PROGRESS = 'TEST_PROGRESS';
export const TEST_FORM = 'TEST_FORM';
export const TEST_DATE = 'TEST_DATE';
export const TEST_PARTNERSELECTION = 'TEST_PARTNERSELECTION';
export const TEST_BARRING_STATUS = 'TEST_BARRING_STATUS';
export const TEST_TABSET = 'TEST_TABSET';
export const TEST_DESCRIPTIONLIST = 'TEST_DESCRIPTIONLIST';
export const TEST_DETAILBOX = 'TEST_DETAILBOX';
export const TEST_TABLE = 'TEST_TABLE';

export const ORDER_OVERVIEW = 'ORDER_OVERVIEW';
export const INTERNAL_CATALOGUE = 'INTERNAL_CATALOGUE';
export const INTERNAL_STOCK = 'INTERNAL_STOCK';

export const CITA = 'CITA';
export const CITA_IDENTIFY = 'CITA_IDENTIFY';
export const CITA_AUTH = 'CITA_AUTH';
export const CITA_REQUEST = 'CITA_REQUEST';
export const CITA_CONFIRM = 'CITA_CONFIRM';
export const CITA_HELP = 'CITA_HELP';

export const AUTH = 'AUTH';
export const AUTH_CONFIRMATION = 'AUTH_CONFIRMATION';
export const UNBARRING = 'UNBARRING';
export const UNBARRING_OTP = 'UNBARRING_OTP';
export const UNBARRING_PIN = 'UNBARRING_PIN';
export const UNBARRING_LANDING_ERROR = 'UNBARRING_LANDING_ERROR';
export const UNBARRING_ERROR = 'UNBARRING_ERROR';
export const UNBARRING_ERROR_FATAL = 'UNBARRING_ERROR_FATAL';

export default {
  HOME,
  ERROR,
  ERROR_FATAL_CODE,
  ERROR_RETRY_CODE,
  ERROR_MEDIUM_CODE,
  ERROR_PARTNER_ADAPTER,

  PRODUCT_CATALOGUE,
  PRODUCT_DETAILS,
  PRODUCT_ORDER_SELECTION,
  PRODUCT_ORDER_FINALIZE,
  PRODUCT_ORDER_ACCOUNT_FINALIZE,
  PRODUCT_ORDER_RESERVATION_CONFIRMATION,
  PRODUCT_ORDER_SUMMARY,
  PRODUCT_ORDER_SUMMARY_OPTIN,
  PRODUCT_ORDER_SUMMARY_RETURN,
  PRODUCT_ORDER_SUMMARY_OPENID_RETURN,
  PRODUCT_ORDER_SUMMARY_FINALIZE,
  PRODUCT_ORDER_CONFIRMATION,
  PRODUCT_ORDER_CONFIRMATION_OPTIN,
  PRODUCT_ORDER_CONFIRMATION_FINALIZE,
  PRODUCT_ADMINISTRATION_SELECTION,
  PRODUCT_ADMINISTRATION_SUMMARY,
  PRODUCT_ADMINISTRATION_CONFIRMATION,
  PRODUCT_ADMINISTRATION_CONFIRMATION_IN_PROGRESS,

  STOCK,
  STOCK_PRODUCT_CHANGE_SELECTION,
  STOCK_PRODUCT_CHANGE_SUMMARY,
  STOCK_PRODUCT_CHANGE_CONFIRMATION,

  AUTO_TOPUP_REGISTRATIONS,
  AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS,

  PAYMENT_TRANSACTIONS,
  PAYMENT_TRANSACTIONS_OVERVIEW,
  PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
  RECHARGE_TRANSACTIONS,
  RECHARGE_TRANSACTIONS_OVERVIEW,
  RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS,
  CONTENT_BUNDLES,
  CONTENT_BUNDLES_OVERVIEW,
  CONTENT_BUNDLES_OVERVIEW_DETAILS,

  PERSISTENT_CONFIRMATIONS,
  PERSISTENT_CONFIRMATIONS_DETAILS,

  CUSTOMER_SEARCH,
  CUSTOMER_SEARCH_REDIRECT,
  CONTRACT_SEARCH,
  CONTRACT_SEARCH_REDIRECT,
  LOGIN,
  LOGOUT,
  PROFILE,

  BARRING_FACTORING_STATUS,
  BARRING_FACTORING_EDIT,
  BARRING_FACTORING_EDIT_EXCEPTIONS,
  BARRING_FACTORING_HISTORY,
  BARRING_FACTORING_HISTORY_STATUS,
  BARRING_FACTORING_HISTORY_SHOW,
  BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS,
  BARRING_RESELLING_STATUS,
  BARRING_RESELLING_EDIT,
  BARRING_RESELLING_HISTORY,
  BARRING_RESELLING_HISTORY_STATUS,
  BARRING_PIN_PROTECTION,

  ORDER_OVERVIEW,
  INTERNAL_CATALOGUE,
  INTERNAL_STOCK,

  TEST,
  TEST_PRICE,
  TEST_PRICEDETAILS,
  TEST_PRODUCT,
  TEST_STOCKPRODUCT,
  TEST_SUBSCRIPTION,
  TEST_PROGRESS,
  TEST_FORM,
  TEST_DATE,
  TEST_PARTNERSELECTION,
  TEST_BARRING_STATUS,
  TEST_TABSET,
  TEST_DESCRIPTIONLIST,
  TEST_DETAILBOX,

  CITA,
  CITA_IDENTIFY,
  CITA_AUTH,
  CITA_REQUEST,
  CITA_CONFIRM,
  CITA_HELP,

  AUTH,
  AUTH_CONFIRMATION,
  PASSWORD,

  UNBARRING,
  UNBARRING_OTP,
  UNBARRING_PIN,
  UNBARRING_LANDING_ERROR,
  UNBARRING_ERROR,
  UNBARRING_ERROR_FATAL,
};
